<script setup lang="ts">
definePageMeta({
  static: true,
  title: 'Política de Cookies'
})
const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [{
    title: 'Política de Cookies'
  }]
}]
</script>
<template>
  <div class="container pb-lg-4 mb-sm-2">
    <Breadcrumb :data="breadcrumbData"/>
    <div class="row">
      <PoliticsMenu activePage="cookies"/>
      <div class="col-lg-8 col-md-7 mb-5">
        <h1 class="mb-4 pb-lg-2 h2">Política de Cookies</h1>
        <p>O site {{ socialInfo.fantasyName }} utiliza cookies para garantir o bom funcionamento da plataforma, reforçar
          a segurança,
          melhorar o desempenho e oferecer uma experiência de navegação mais personalizada aos usuários.</p>
        <p>As informações coletadas por meio de cookies não permitem identificar dados pessoais diretamente. Todavia,
          caso a legislação aplicável passe a considerar tais informações como dados pessoais, a
          {{ socialInfo.fantasyName }} cumprirá
          rigorosamente as normas vigentes.</p>
        <p>Este documento explica de forma objetiva como utilizamos cookies, quais tipos estão presentes em nosso site e
          como você pode gerenciá-los.</p>
        <h4 class="h4"><b>1. O que são Cookies?</b></h4>
        <p>Cookies são pequenos arquivos de texto armazenados no navegador ou dispositivo do usuário durante a navegação
          em um site. Eles registram informações básicas sobre sua visita, permitindo que determinadas funcionalidades
          funcionem corretamente e que sua experiência seja mais fluida.</p>
        <ul>
          <li><b>Cookies primários: </b>criados e utilizados diretamente pelo nosso site.
            Cookies de terceiros: instalados por serviços parceiros integrados ao nosso site (como Google, por
            exemplo).
          </li>
          <li><b>Cookies de sessão:</b>armazenados temporariamente e excluídos ao encerrar a navegação ou fazer
            logout.
          </li>
          <li><b>Cookies persistentes:</b>permanecem em seu dispositivo por um período determinado ou até que sejam
            apagados manualmente.
          </li>
        </ul>
        <p>O usuário pode gerenciar a aceitação ou bloqueio de cookies diretamente nas configurações de seu navegador.
          No entanto, a recusa pode comprometer a utilização de algumas funcionalidades da plataforma.</p>
        <h4 class="h4"><b>2. Quais tipos de Cookies utilizamos?</b></h4>
        <h5 class="h5"><b>2.1 Cookies Essenciais</b></h5>
        <p>Necessários para o funcionamento do site e a prestação dos serviços contratados. Sem eles, certas
          funcionalidades podem ficar indisponíveis.
          Exemplos: autenticação de login, registro de preferências de privacidade e preenchimento de formulários.
          Esses cookies não armazenam informações que permitam a identificação pessoal do usuário.
        </p>
        <ul>
          <li><b>Essenciais primários</b></li>
          <li><b>Essenciais de terceiros</b></li>
        </ul>
        <h5 class="h5"><b>2.2 Cookies Analíticos</b></h5>
        <p>Utilizados para entender como os visitantes interagem com o site, permitindo identificar páginas mais
          acessadas, mapear dificuldades de navegação e avaliar o desempenho.
          Normalmente são fornecidos por terceiros (como ferramentas de análise de tráfego). Para gerenciá-los, o
          usuário deve acessar diretamente a política de privacidade desses provedores.</p>
        <h5 class="h5"><b>2.3 Cookies de Publicidade</b></h5>
        <p>Usados para oferecer anúncios mais relevantes, medir a eficácia de campanhas e limitar a frequência com que
          um mesmo anúncio é exibido.
          Esses cookies podem coletar informações de navegação em diferentes sites para criar perfis de interesse.</p>
        <h4 class="h4"><b>3. Como gerenciar os Cookies?</b></h4>
        <p>
          A maioria dos navegadores aceita cookies automaticamente, mas você pode configurar o seu para rejeitá-los,
          alertar quando um cookie estiver sendo enviado ou apagar cookies já armazenados.
        </p>
        <ul>
          <li>Desativar uma categoria de cookies não remove automaticamente os que já foram coletados. A exclusão deve
            ser feita manualmente pelo usuário nas configurações do navegador.
          </li>
          <li>Caso opte por bloquear todos os cookies, algumas funcionalidades, como login ou recursos personalizados,
            podem deixar de funcionar corretamente.
          </li>
        </ul>
        <h4 class="h4"><b>4. Disposições Gerais</b></h4>
        <p>Ao acessar e utilizar o site {{ socialInfo.fantasyName }}, o usuário declara estar ciente e de acordo com
          esta Política de
          Cookies e demais políticas aplicáveis.</p>
        <p>A {{ socialInfo.fantasyName }} poderá atualizar este documento sempre que necessário para refletir alterações
          técnicas, legais ou
          de funcionamento. Recomendamos que você consulte esta página regularmente para manter-se informado sobre
          possíveis mudanças.</p>
      </div>
    </div>
  </div>
</template>
<style scoped>
p {
  text-align: justify;
  opacity: 70;
  font-size: 14px;
}

.me-icon {
  font-size: 50px;
}
</style>
